import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import style from './style.module.scss';

const PDFItem = ({ onDelete, file }) => {
  const type = file && file.type;
  const typeSplited = type && type.split('/');
  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(file);
  };

  return (
    <div className={style.pdfItem}>
      <span className={style.deleteButton} onClick={handleDelete}>
        <Icon name="close" className={style.deleteIcon} />
      </span>
      <span className={style.pdfContainer}>
        {typeSplited && typeSplited[1] && (typeSplited[1] || '').toUpperCase()}
      </span>
      <span className={style.pdfText}>{file && file.name}</span>
    </div>
  );
};

PDFItem.propTypes = {
  onDelete: PropTypes.func,
};

export default PDFItem;
